import React, { useState } from "react";
import uoLogo from "../../assets/uo_logo.png";

import stylelist from "stylelist";
import IfCondition from "../Util/IfCondition";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { update_user_profile } from "../../actions/User";
import { set_sync_status } from "../../actions/Sync";
import Gravatar from "../../libs/Gravatar";
import SharkIf from "../Util/IfCondition";


const Welcome = (props) => {
  const [showAdvanced, setShowAdvanced] = useState(false);
  const UserSettings = useSelector((state) => state.User);
  const dispatch = useDispatch();
  const [isValidEmail, setIsValidEmail] = useState(false);
  const [isValidToken, setIsValidToken] = useState(false);
  const [customApiUrl, setCustomApiUrl] = useState(localStorage.getItem('customApiUrl') || '');

  const toggleShowAdvanced = () => {
    setShowAdvanced(!showAdvanced);
  }

  const updateUserData = (event) => {
    dispatch(update_user_profile(event.target.id, event.target.value));

    if (event.target.id == "email" && validateEmail(event.target.value)) {
      setIsValidEmail(true);
    }

    if (event.target.id == "syncToken" && event.target.value.length > 5) {
      dispatch(set_sync_status("asap"));
      setIsValidToken(true);
    }
  }

  const validateEmail = (email) => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  const handleApiUrlChange = (e) => {
    setCustomApiUrl(e.target.value);
  }

  const applyCustomApiUrl = () => {
    if (customApiUrl.trim()) {
      const url = customApiUrl.trim().endsWith('/') ? customApiUrl.trim() : customApiUrl.trim() + '/';
      localStorage.setItem('customApiUrl', url);
      window.location.reload();
    } else {
      localStorage.removeItem('customApiUrl');
      window.location.reload();
    }
  }

  return (
    <>
      <div className="card border-0" style={{ boxShadow: 'none' }}>
        <div className="card-body">
          <div className="row">

            {!UserSettings["firstLaunchDone"] &&
              <div className="d-flex justify-content-center">
                <div>

                  <h1 className="text-center mt-5 pt-5 mb-1 text-portal">Slotify</h1>
                  
                  {localStorage.getItem('customApiUrl') && (
                    <div className="text-center mb-3">
                      <span className="badge rounded-pill bg-primary bg-gradient shadow-sm px-3 py-2">
                        <i className="bi bi-code-slash me-1"></i>
                        Non-Prod API
                      </span>
                    </div>
                  )}

                  <SharkIf animate={true} show={true} animation="fade" animationDelay={300}>
                    <div className="d-flex justify-content-center mt-2">
                      <Gravatar size={150} className={stylelist("avatar")} default="mp" email={UserSettings.email} />
                    </div>
                  </SharkIf>

                  <div className="form-group mb-3 mt-3">
                    <label htmlFor="email">E-Mailadresse</label>
                    <input autoComplete="off" value={UserSettings.email} onAnimationStart={updateUserData} onChange={updateUserData} type="text" className="form-control" name="email" id="email" />
                  </div>

                  <div className="form-group mb-4">
                    <label htmlFor="token">Passwort</label>
                    <input autoComplete="off" value={UserSettings.synctoken} onAnimationStart={updateUserData} onChange={updateUserData} type="password" className="form-control" name="token" id="syncToken" />
                  </div>

                  <SharkIf animate={true} show={true} animation="fade" animationDelay={300}>
                    <>
                      <div className="d-flex justify-content-center mb-4">
                        <a onClick={() => { dispatch(set_sync_status("asap")); }} className="btn btn-primary mx-auto text-center">Login</a> <br />
                      </div>
                    </>
                  </SharkIf>

                  <div className="d-flex justify-content-center text-muted">
                    <small>Wir versuchen bereits, dich beim Tippen einzuloggen.</small>
                  </div>

                  <p className="text-primary text-center mt-4 cursor-pointer" onClick={toggleShowAdvanced}>
                    <small>{showAdvanced ? '▼' : '▶'} Entwicklungsoptionen</small>
                  </p>

                  <IfCondition show={showAdvanced} animate={true} animation="fade" animationDelay={100}>
                    <div className="mt-3">
                      <div className="form-group mb-3">
                        <label htmlFor="customApiUrl"><small>API-URL überschreiben</small></label>
                        <div className="input-group input-group-sm">
                          <input 
                            autoComplete="off" 
                            value={customApiUrl} 
                            onChange={handleApiUrlChange}
                            type="text" 
                            className="form-control" 
                            name="customApiUrl" 
                            id="customApiUrl"
                            placeholder="z.B. https://api-dev.example.com/"
                          />
                        </div>
                        {customApiUrl && (
                          <small className="text-muted d-block mt-2">
                            <i className="bi bi-info-circle me-1"></i>
                            Aktuelle URL: <strong>{customApiUrl}</strong>
                          </small>
                        )}
                      </div>
                      <div className="d-flex justify-content-center gap-2">
                        <button onClick={applyCustomApiUrl} className="btn btn-sm btn-outline-primary">
                          Übernehmen
                        </button>
                        {customApiUrl && (
                          <button 
                            onClick={() => { setCustomApiUrl(''); localStorage.removeItem('customApiUrl'); window.location.reload(); }} 
                            className="btn btn-sm btn-outline-secondary"
                          >
                            Zurücksetzen
                          </button>
                        )}
                      </div>
                    </div>
                  </IfCondition>
                </div>

              </div>
            }
          </div>
        </div>
 
      </div>
    </>
  );
};

export default Welcome;
